import React, { Component } from 'react'
import popupImg from '../images/discount_banner.jpg'
let dialogStyles = {
    maxWidth: '700px',
    width: '80%',
    margin: '0 auto',
    position: 'fixed',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    zIndex: '999',
    backgroundColor: '#eee',
    padding: '10px 20px 40px',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column'
};

let dialogCloseButtonStyles = {
    marginBottom: '15px',
    padding: '3px 8px',
    cursor: 'pointer',
    borderRadius: '50%',
    border: 'none',
    width: '15px',
    Height: '15px',
    fontWeight: 'bold',
    alignSelf: 'flex-end'
};

let imgStyles = {
    height: '65vw',
    maxHeight: '500px'

}
export default class Dialog extends Component {
    render() {
        let dialog = (
            <div style={dialogStyles}>
                <button style={dialogCloseButtonStyles} onClick={this.props.modalOnClose}>X</button>
                <img src={popupImg} style={imgStyles}></img>
            </div>
        );
        if (!this.props.modalIsOpen) {
            dialog = null;
        }
        return (
            <div>
                {dialog}
            </div>
        );
    }
}
